import './FailReportStatusTag.scss';

import { Tag } from 'antd';
import { useTranslation } from 'react-i18next';

import { FAIL_REPORT_STATUS, FailReportStatusString } from '@/model/FailReport/FailReport';

interface FailReportStatusTagProps {
  failReportStatus: FAIL_REPORT_STATUS;
}

const FailReportStatusTag = (props: FailReportStatusTagProps) => {
  const { t } = useTranslation();
  const { failReportStatus } = props;

  return (
    <Tag
      color={
        failReportStatus == FAIL_REPORT_STATUS.CANCELED
          ? 'gray'
          : failReportStatus == FAIL_REPORT_STATUS.CLOSED
            ? 'default'
            : failReportStatus == FAIL_REPORT_STATUS.RESOLVED
              ? 'green'
              : failReportStatus == FAIL_REPORT_STATUS.STATUS_PENDING
                ? 'blue'
                : failReportStatus == FAIL_REPORT_STATUS.INSTANCE_2
                  ? 'orange'
                  : failReportStatus == FAIL_REPORT_STATUS.INSTANCE_1
                    ? 'volcano'
                    : 'default'
      }
      className={'FailReportStatusTag'}>
      {t(FailReportStatusString[failReportStatus])}
    </Tag>
  );
};

export default FailReportStatusTag;
